

interface ProgressBarProps {
  value: number;
  max?: number;
  color?: 'blue' | 'green' | 'yellow' | 'red' | 'purple';
  showLabel?: boolean;
  className?: string;
}

export function ProgressBar({
  value,
  max = 100,
  color = 'blue',
  showLabel = true,
  className = '',
}: ProgressBarProps) {
  const percentage = Math.min(Math.max((value / max) * 100, 0), 100);

  const getColor = () => {
    if (color === 'blue') return 'bg-blue-500';
    if (color === 'green') return 'bg-green-500';
    if (color === 'yellow') return 'bg-yellow-500';
    if (color === 'red') return 'bg-red-500';
    if (color === 'purple') return 'bg-purple-500';
    return 'bg-blue-500';
  };

  const getBackgroundColor = () => {
    if (color === 'blue') return 'bg-blue-500/20';
    if (color === 'green') return 'bg-green-500/20';
    if (color === 'yellow') return 'bg-yellow-500/20';
    if (color === 'red') return 'bg-red-500/20';
    if (color === 'purple') return 'bg-purple-500/20';
    return 'bg-blue-500/20';
  };

  return (
    <div className={className}>
      <div className={`w-full h-2 rounded-full overflow-hidden ${getBackgroundColor()}`}>
        <div
          className={`h-full rounded-full transition-all duration-300 ${getColor()}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      {showLabel && (
        <div className="mt-1 text-xs text-dark-400">
          {percentage.toFixed(1)}%
        </div>
      )}
    </div>
  );
}
